const $ = jQuery.noConflict();

'use strict';
const UploadImage = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.fileUpload();
	},

	fileUpload: () => {
		$('.js-image-input').on('change', function() {
			updateList($(this));
		});

		function updateList(input) {
			const output = input.closest('.js-upload-wrap-image').find('.js-image-list');
			const files = input[0].files;
			for (let i = 0; i < files.length; ++i) {
				const file = files[i];
				if (isAllowedFileType(file)) {
					output.append('<li> <span class="upload-image-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"/></svg></span>' + '<span class="doc-text">' + file.name + '</span>' + '<span class="js-remove-doc remove-doc"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg></span>' + '</li>');
				} else {
					const errorMessage = $('<span class="file-error-message">Only JPEG and PNG accepted</span>');
					$('.js-custom-file-image').append(errorMessage);
					setTimeout(function() {
						errorMessage.remove();
					}, 5000);
				}
			}
		}

		function isAllowedFileType(file) {
			const allowedTypes = ['image/jpeg', 'image/png'];
			return allowedTypes.includes(file.type);
		}

		$(document).on('click', '.js-remove-doc', function() {
			$(this).parent().remove();
		});
	}
};

export default UploadImage;